import { render } from "./click_to_copy.vue?vue&type=template&id=7628cae7"
import script from "./click_to_copy.vue?vue&type=script&lang=js"
export * from "./click_to_copy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__